<p>ll-exam-sections-occupancy works!</p>
